export default __webpack_public_path__ + "static/media/iv_footer.3d6a30f7.svg";